<template>
  <div>
    <v-btn
      :color="color"
      :class="cssClass"
      :size="size"
      :outlined= outlined
      :rounded= rounded
      :disabled="disabled"
      :text= text 
      :elevation="0"
      :style="makeStyle({ variant, contained })"
      @click="e => this.$emit('click',e)">
      {{ label }}
    </v-btn>
  </div>
</template>

<script>
import colors from '../../styles/colors';

const baseStyle = {
  height: '2.5rem',
  minWidth: '4rem',
  borderRadius: '0.3rem',
};

const makeStyle = ({
  variant,
  contained
}) => ({
  ...baseStyle,
  backgroundColor: contained ? `${colors[variant]} !important` : 'transparent',
  border: !contained ? `0.667px solid ${colors[variant]}` : 'none',
  color: !contained ? colors[variant] : 'white'
});

export default {
  props: {
    contained: Boolean,
    color: String,
    cssClass: String,
    label: String,
    outlined: Boolean,
    rounded: Boolean,
    size: String,
    text: Boolean,
    disabled: Boolean,
    variant: String,
  },
  data() {
    return {
      styles: {
        primary: {
          ...baseStyle,
          backgroundColor: 'primary'
        }
      }
    }
  },
  methods: {
    makeStyle
  }
};
</script>